module.exports = (parcelRequire.load("2wmCK")).then(() => parcelRequire('6IYG4'));